/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  ListTradingChallengeRegistrationRequestsOptions,
  ListTradingChallengeRegistrationRequestsResponses,
} from '../types/ListTradingChallengeRegistrationRequests'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description The review queue. Admins see every tenant and may filter to one, an integrator is pinned to their own tenant, and a competition manager only sees the requests of the challenges assigned to them.
 * @summary List trading challenge registration requests
 * {@link /v1/trading_challenges/registration_requests}
 */
export function listTradingChallengeRegistrationRequests<ThrowOnError extends boolean = true>(
  options: Options<ListTradingChallengeRegistrationRequestsOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<ListTradingChallengeRegistrationRequestsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/trading_challenges/registration_requests',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ListTradingChallengeRegistrationRequestsResponses, ThrowOnError>>,
  )
}
